// prettier-ignore
export default "2025.0603.1547"